<template>
	<div class="tab-page">
		<FilteredSearch :loaded="documentsLoaded" :list="documents" :click="documentClick" :customText="documentText" :placeholder="$t('search')" :filterAttributes="filterAttributes"/>
	</div>
</template>

<script>
import FilteredSearch from '@/components/FilteredSearch.vue'

export default {
	data() {
		return {
			documents: [],
			documentsLoaded: false,
			filterAttributes: [
				{attribute: 'name', text: this.$t('name')},
				{attribute: 'description', text: this.$t('description')},
			],
		}
	},
	computed: {
		username() {
			return this.$store.getters.getProfile.name;
		},
		id() {
			return this.$store.getters.getProfile.id;
		}
	},
	methods: {
		documentClick(item) {
			let download = (blob) => {
				let fileName = `${item.name}.pdf`;

				if (!window.isCordovaApp) {
					window.downloadFile(blob, fileName);
				} else {
					let dirName = window.cordova.file.dataDirectory;
					window.writeFile(blob, dirName, fileName)
					.then((fileEntry, type) => {
						return window.openFile(fileEntry, blob.type);
					})
					.then(() => {

					})
					.catch((err) => {
						console.log(err);
						self.$snack.danger({button: null, text: self.$t('create-file-error')});
					});
				}
			}

			let self = this;

			
			let config = {
				responseType: 'blob', // important
				// onUploadProgress: function(progressEvent) {
				// 	let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
				// 	self.$set(file, 'percentCompleted', percentCompleted);
				// },
			};
			
			axios.get(`/machines/${self.$route.params.id}/documents/${item.documentId}/file`, config)
			.then((response) => {
				download(response.data);
			});

		},
		documentText(item) {
			return `${item.name}`;
		},
	},
	components: {
		FilteredSearch
	},
	created() {
		let self = this;
		axios.get(`/machines/${self.$route.params.id}/documents`)
		.then((response) => {
			self.documents = [...response.data.response.machineDocuments];
			self.documentsLoaded = true;
		});
	},
}
</script>

<style scoped>
</style>